import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { useContext, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import NumberUtil from "../../utility/NumberUtil";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { parseTabPermissions } from "../../utility/service/tab-permission-utils";
import { Base64Encoder, BcryptEncoder, checkDpSuccess } from "../../utility/service/tool-service";
import { AcctContext } from "../../utility/useReduce/userNameReduce";
import DataQualityTabPanel from "./cusComponents/DataQualityTabPanel";
import RawMaterial from "./cusComponents/RawMaterial";
import SensitivityAnalysis from "./cusComponents/SensitivityAnalysis";
import TotalCarbonFootprint from "./cusComponents/TotalCarbonFootprint";
import {
  downloadCarbonFootprintTemplateExcel,
  importCarbonFootprintTemplateExcel,
} from "../../utility/service/carbonFootprint-service";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { handleFileDownloadRes } from "../../utility/service/api-base";
import { AlertService } from "../../utility/service/alert-service";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import { FormInputFile } from "../../components/FormInputFile";
import ImagePDFComponent from "../../components/ImagePDFComponent";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";

// 足跡盤查
const FootprintInventory_Index = () => {
  const {
    itemObj,
    setItemObj,
    action,
    setAction,
    stageList,
    setStageList,
    setReportListObj,
    setTab1Action,
  } = useOutletContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [addDialog, setAddDialog] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [lifeCycleList, setLifeCycleList] = useState([]);
  const [unitCodeList, setUnitCodeList] = useState([]);
  const [groupCodeList, setGroupCodeList] = useState([]);
  const [distributionPrincipleList, setDistributionPrincipleList] = useState([]);
  const isEditable = useEditableFlag("F10503"); // control edit by F10503
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗

  // Tab 權限控制
  const [state] = useContext(AcctContext);
  const [accessibleTabs, setAccessibleTabs] = useState([]);

  // 匯入檔案
  const [previewUrl, setPreviewUrl] = useState(null);
  const [importFileInfo, setImportFileInfo] = useState(null);
  const [importFile, setImportFile] = useState(null);
  const importfileInputRef = useRef(null);
  const [importPopup, setImportPopup] = useState(false);
  const [importFlag, setImportFlag] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    control,
    clearErrors,
    reset,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      distributionReason: "0", // 分配原則預設值
    },
    //錯誤驗證時機
    mode: "all",
  });

  // 載入頁籤權限
  useEffect(() => {
    const loadTabPermissions = () => {
      try {
        // 從全域狀態獲取 F10503 的頁籤權限信息
        const tabPermissions = state?.tabPermissions?.["F10503"];

        if (!tabPermissions || tabPermissions.trim() === "") {
          // 如果沒有權限設定，設為空陣列（無任何權限）
          setAccessibleTabs([]);
          return;
        }

        // 解析頁籤權限字串
        const accessibleTabs = parseTabPermissions(tabPermissions);
        setAccessibleTabs(accessibleTabs);
      } catch (error) {
        // 如果載入失敗，設為空陣列（無任何權限）
        setAccessibleTabs([]);
      }
    };

    loadTabPermissions();
  }, [state?.tabPermissions]); // 依賴頁籤權限變化

  // 檢查特定 tab 是否有權限
  const hasTabPermission = (tabName) => {
    return accessibleTabs.includes(tabName);
  };

  // 處理 tab 點擊（移除 alert，直接進入頁面）
  const handleTabClick = (tabName, tabIndex) => {
    // 直接設定 activeIndex，讓頁面顯示權限提示內容
    setActiveIndex(tabIndex);
  };

  const btnBackTo = () => {
    navigate("/management/inventoryCarbonFootprint");
  };

  // 處理報告書點擊
  const handleReportClick = () => {
    // 設定報告書相關狀態
    setReportListObj([itemObj]);
    setAction("report");
    setTab1Action("report");

    // 跳轉到報告書頁面
    navigate("/management/inventoryCarbonFootprint/report", {
      state: {
        companyName: itemObj?.companyName,
        activeIndex: activeIndex, // 保存當前步驟位置
      },
    });
  };

  const findLifeCycleIndex = (array, code) => {
    let result = array?.filter((item) => item.subitemNo === code);
    return result.length > 0 ? result[0].index : false;
  };

  const axios_getDropdownList = () => {
    // getSubItemsByItemNo('LIFE_CYCLE',29)
    //     .then((res)=>{
    //         if(checkDpSuccess(res)){
    //             let data = res.data.RespBody.subItems;
    //             let newArray = data.map((item, index) => {
    //                 return {
    //                 ...item,
    //                 index: index,
    //                 }
    //             })
    //             setLifeCycleList(newArray);
    //             setStageList(newArray?.map((item,index)=>{
    //               return {
    //                 subitemNo:item.subitemNo,
    //                 index,
    //                 stage:convertBscryptCode(item.subitemNo,index)
    //               }
    //             }))

    //         }
    //     })

    getSubItemsByItemNo("COEFFICIENT_UNIT", 27).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setUnitCodeList(newArray);
      }
    });
    getSubItemsByItemNo("COEFFICIENT_GROUP", 28).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setGroupCodeList(newArray);
      }
    });
    getSubItemsByItemNo("DISTRIBUTION_REASON", 41).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setDistributionPrincipleList(newArray);
      }
    });
  };

  const convertBscryptCode = (code, index) => {
    if (code) return Base64Encoder(BcryptEncoder(code)) + "," + index;
    else return "";
  };

  useEffect(() => {
    axios_getDropdownList();
  }, []);

  useEffect(() => {
    if (JSON.stringify(itemObj) === "{}") {
      btnBackTo();
    }
  }, [itemObj]);

  // 下載模板及資料
  const downloadCarbonTemplate = () => {
    checkLoading(loading);
    const reqBody = {
      carbonFpId: itemObj?.carbonFpId,
      companySeq: itemObj?.companySeq,
    };
    downloadCarbonFootprintTemplateExcel(reqBody)
      .then((res) => {
        if (res?.status === 200) {
          handleFileDownloadRes(
            res,
            `${itemObj?.inspectionDate}_${itemObj?.productName}_${itemObj?.productTypeName}_${itemObj?.companyName}_template.xlsx`,
          );
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  // 匯入資料
  const importCarbonTemplate = () => {
    let formData = new FormData();
    formData.append("carbonFpId", itemObj?.carbonFpId);
    formData.append("companySeq", itemObj?.companySeq);
    formData.append("file", importFile);
    console.log(itemObj);
    checkLoading(loading);
    importCarbonFootprintTemplateExcel(formData)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.import") + " " + t("message.success"));
          setImportFlag(prev => !prev);
        }
      })
      .finally(() => {
        setPreviewUrl(null);
        setImportFileInfo(null);
        setImportFile({});
        setImportFile(null);
        setImportPopup(false);
        checkLoading(loading, false);
      });
  };

  // 每次開啟選擇檔案觸發onChange事件
  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    const imgSize = 5000000; // 20MB

    if (file.size >= imgSize) {
      AlertService.ok("Error", `Size over 5MB`);
      setPreviewUrl(null);
      setImportFileInfo(null);
      setImportFile({});
      if (importfileInputRef.current) {
        importfileInputRef.current.value = null;
      }
    } else {
      const objectURL = URL.createObjectURL(file);
      setPreviewUrl(objectURL);
      setImportFileInfo(file);
      setImportFile(file);
    }
  };

  // 刪除圖片
  const handleDeleteImg = () => {
    if (importfileInputRef?.current?.value !== undefined) {
      importfileInputRef.current.value = null;
      setPreviewUrl(null);
      setImportFileInfo(null);
      setImportFile({});
    }
  };

  return (
    <>
      {/* 返回上頁 */}
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              btnBackTo();
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
      </div>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <div className="grid">
            <div className="col-12">
              <h3 className="m-0">{itemObj?.companyName}</h3>
            </div>
            <div className="col-12 md:col-4 p-0">
              <label className="label-has-icon">{t("productName")}:</label>
              <span>{itemObj?.productName}</span>
            </div>
            <div className="col-12 md:col-4 p-0">
              <label className="label-has-icon">
                {t("total_quantity")}/{t("declareUnit")}:
              </label>
              <span>
                {NumberUtil.formatWithCommas(itemObj?.quantity)} {itemObj?.declaringUnitName}
              </span>
            </div>
            <div className="col-12 md:col-4 p-0">
              <label className="label-has-icon">{t("inventoryDate")}:</label>
              <span>{itemObj?.inspectionDate}</span>
            </div>
            {activeIndex === 7 && (
              <>
                <div className="col-12 md:col-6 p-0">
                  <label className="label-has-icon">{t("productReliabilityScore")}:</label>
                  <span>{itemObj?.productReliability}</span>
                </div>
                <div className="col-12 md:col-6 p-0">
                  <label className="label-has-icon">{t("productIntegrityScore")}:</label>
                  <span>{itemObj?.productIntegrity}</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-content-end gap-2">
        <Button
          type="button"
          size="small"
          label={t("button.downloadCarbonFootprintTemplate")}
          onClick={downloadCarbonTemplate}
        />
        <Button
          type="button"
          size="small"
          label={t("button.importCarbonFootprintTemplate")}
          onClick={() => {
            setImportPopup(true);
          }}
        />
      </div>

      <div className="p-card">
        <div className="p-card-body">
          {/* renderActiveOnly={false}  */}
          <TabView
            scrollable
            renderActiveOnly={true}
            activeIndex={activeIndex}
            onTabChange={(e) => {
              // 定義 tab 名稱對應
              const tabNames = [
                "raw_material",
                "manufacturing",
                "distribution",
                "use_phase",
                "service_phase",
                "disposal_phase",
                "footprint_calculation",
                "data_quality",
                "sensitivity_analysis",
                "report",
              ];

              const tabName = tabNames[e.index];

              // 如果是報告書 tab（最後一個 tab），檢查權限後決定是否跳轉
              if (e.index === 9) {
                // 報告書是第10個 tab（索引9）
                if (hasTabPermission("report")) {
                  handleReportClick();
                } else {
                  // 無權限時，直接進入頁面顯示權限提示
                  setActiveIndex(e.index);
                }
              } else {
                handleTabClick(tabName, e.index);
              }
            }}
          >
            <TabPanel header={t("stage.rawMaterial")}>
              {hasTabPermission("raw_material") ? (
                <RawMaterial
                  key={importFlag}
                  register={register}
                  errors={errors}
                  control={control}
                  reset={reset}
                  isValid={isValid}
                  setValue={setValue}
                  getValues={getValues}
                  stage={stageList?.filter((item) => item.subitemNo === "rawMaterial")[0]?.stage}
                  clearErrors={clearErrors}
                  trigger={trigger}
                  unitCodeList={unitCodeList}
                  groupCodeList={groupCodeList}
                  distributionPrincipleList={distributionPrincipleList}
                  convertBscryptCode={convertBscryptCode}
                  watch={watch}
                  isEditable={isEditable}
                />
              ) : (
                <div className="text-center p-4">
                  <h3>{t("no_permission_title")}</h3>
                  <p>{t("no_permission_message")}</p>
                </div>
              )}
            </TabPanel>

            {itemObj?.productType === "G" && (
              <TabPanel header={t("stage.manufacturing")}>
                {hasTabPermission("manufacturing") ? (
                  <RawMaterial
                    key={importFlag}
                    register={register}
                    errors={errors}
                    control={control}
                    reset={reset}
                    isValid={isValid}
                    setValue={setValue}
                    getValues={getValues}
                    stage={stageList?.filter((item) => item.subitemNo === "manufacturing")[0]?.stage}
                    clearErrors={clearErrors}
                    trigger={trigger}
                    unitCodeList={unitCodeList}
                    groupCodeList={groupCodeList}
                    distributionPrincipleList={distributionPrincipleList}
                    convertBscryptCode={convertBscryptCode}
                    watch={watch}
                    isEditable={isEditable}
                  />
                ) : (
                  <div className="text-center p-4">
                    <h3>{t("no_permission_title")}</h3>
                    <p>{t("no_permission_message")}</p>
                  </div>
                )}
              </TabPanel>
            )}

            {itemObj?.productType === "G" && (
              <TabPanel header={t("stage.distribution")}>
                {hasTabPermission("distribution") ? (
                  <RawMaterial
                    key={importFlag}
                    register={register}
                    errors={errors}
                    control={control}
                    reset={reset}
                    isValid={isValid}
                    setValue={setValue}
                    getValues={getValues}
                    stage={stageList?.filter((item) => item.subitemNo === "distribution")[0]?.stage}
                    clearErrors={clearErrors}
                    trigger={trigger}
                    unitCodeList={unitCodeList}
                    groupCodeList={groupCodeList}
                    distributionPrincipleList={distributionPrincipleList}
                    convertBscryptCode={convertBscryptCode}
                    watch={watch}
                    isEditable={isEditable}
                  />
                ) : (
                  <div className="text-center p-4">
                    <h3>{t("no_permission_title")}</h3>
                    <p>{t("no_permission_message")}</p>
                  </div>
                )}
              </TabPanel>
            )}

            {itemObj?.productType === "G" && (
              <TabPanel header={t("stage.use")}>
                {hasTabPermission("use_phase") ? (
                  <RawMaterial
                    key={importFlag}
                    register={register}
                    errors={errors}
                    control={control}
                    reset={reset}
                    isValid={isValid}
                    setValue={setValue}
                    getValues={getValues}
                    stage={stageList?.filter((item) => item.subitemNo === "use")[0]?.stage}
                    clearErrors={clearErrors}
                    trigger={trigger}
                    unitCodeList={unitCodeList}
                    groupCodeList={groupCodeList}
                    distributionPrincipleList={distributionPrincipleList}
                    convertBscryptCode={convertBscryptCode}
                    watch={watch}
                    isEditable={isEditable}
                  />
                ) : (
                  <div className="text-center p-4">
                    <h3>{t("no_permission_title")}</h3>
                    <p>{t("no_permission_message")}</p>
                  </div>
                )}
              </TabPanel>
            )}
            {itemObj?.productType === "S" && (
              <TabPanel header={t("stage.service")}>
                {hasTabPermission("service_phase") ? (
                  <RawMaterial
                    key={importFlag}
                    register={register}
                    errors={errors}
                    control={control}
                    reset={reset}
                    isValid={isValid}
                    setValue={setValue}
                    getValues={getValues}
                    stage={stageList?.filter((item) => item.subitemNo === "service")[0]?.stage}
                    clearErrors={clearErrors}
                    trigger={trigger}
                    unitCodeList={unitCodeList}
                    groupCodeList={groupCodeList}
                    distributionPrincipleList={distributionPrincipleList}
                    convertBscryptCode={convertBscryptCode}
                    watch={watch}
                    isEditable={isEditable}
                  />
                ) : (
                  <div className="text-center p-4">
                    <h3>{t("no_permission_title")}</h3>
                    <p>{t("no_permission_message")}</p>
                  </div>
                )}
              </TabPanel>
            )}

            <TabPanel header={t("stage.disposal")}>
              {hasTabPermission("disposal_phase") ? (
                <RawMaterial
                  key={importFlag}
                  register={register}
                  errors={errors}
                  control={control}
                  reset={reset}
                  isValid={isValid}
                  setValue={setValue}
                  getValues={getValues}
                  stage={stageList?.filter((item) => item.subitemNo === "disposal")[0]?.stage}
                  clearErrors={clearErrors}
                  trigger={trigger}
                  unitCodeList={unitCodeList}
                  groupCodeList={groupCodeList}
                  distributionPrincipleList={distributionPrincipleList}
                  convertBscryptCode={convertBscryptCode}
                  watch={watch}
                  isEditable={isEditable}
                />
              ) : (
                <div className="text-center p-4">
                  <h3>{t("no_permission_title")}</h3>
                  <p>{t("no_permission_message")}</p>
                </div>
              )}
            </TabPanel>

            <TabPanel header={t("stage.footCalc")}>
              {hasTabPermission("footprint_calculation") ? (
                <TotalCarbonFootprint
                  key={importFlag}
                  productType={itemObj?.productType}
                  register={register}
                  errors={errors}
                  control={control}
                  reset={reset}
                  isValid={isValid}
                  setValue={setValue}
                  getValues={getValues}
                  unitCodeList={unitCodeList}
                  groupCodeList={groupCodeList}
                  distributionPrincipleList={distributionPrincipleList}
                  convertBscryptCode={convertBscryptCode}
                  stageList={stageList}
                  watch={watch}
                  isEditable={isEditable}
                />
              ) : (
                <div className="text-center p-4">
                  <h3>{t("no_permission_title")}</h3>
                  <p>{t("no_permission_message")}</p>
                </div>
              )}
            </TabPanel>

            <TabPanel header={t("stage.dataQualtity")}>
              {hasTabPermission("data_quality") ? (
                <DataQualityTabPanel
                  key={importFlag}
                  productType={itemObj?.productType}
                  getValues={getValues}
                  reset={reset}
                  control={control}
                  register={register}
                  errors={errors}
                  itemObj={itemObj}
                  setValue={setValue}
                  setItemObj={setItemObj}
                  watch={watch}
                  isEditable={isEditable}
                />
              ) : (
                <div className="text-center p-4">
                  <h3>{t("no_permission_title")}</h3>
                  <p>{t("no_permission_message")}</p>
                </div>
              )}
            </TabPanel>

            <TabPanel header={t("stage.sensitivityAnalysis")}>
              {hasTabPermission("sensitivity_analysis") ? (
                <SensitivityAnalysis
                  key={importFlag}
                  productType={itemObj?.productType}
                  itemObj={itemObj}
                  stageList={stageList}
                  unitCodeList={unitCodeList}
                  groupCodeList={groupCodeList}
                  register={register}
                  errors={errors}
                  control={control}
                  reset={reset}
                  isValid={isValid}
                  setValue={setValue}
                  getValues={getValues}
                  watch={watch}
                  isEditable={isEditable}
                />
              ) : (
                <div className="text-center p-4">
                  <h3>{t("no_permission_title")}</h3>
                  <p>{t("no_permission_message")}</p>
                </div>
              )}
            </TabPanel>

            <TabPanel header={t("button.report")}>
              {hasTabPermission("report") ? (
                <div className="text-center p-4">
                  <h3>{t("button.report")}</h3>
                  <p>{t("report.description") || "點擊上方報告書按鈕查看報告書"}</p>
                </div>
              ) : (
                <div className="text-center p-4">
                  <h3>{t("no_permission_title")}</h3>
                  <p>{t("no_permission_message")}</p>
                </div>
              )}
            </TabPanel>
          </TabView>
        </div>
      </div>

      {/* 匯入資料 */}
      <PrimeDialog
        visible={importPopup}
        onClose={() => {
          setImportPopup(false);
          setPreviewUrl(null);
          setImportFileInfo(null);
          setImportFile({});
          setImportFile(null);
        }}
        onConfirm={() => {
          importCarbonTemplate();
        }}
        title={t("button.importCarbonFootprintTemplate")}
        bodyTemplate={
          <div className="border-round p-3">
            <i className="pi pi-info-circle mb-3 text-orange-500"> {t("importContent")}</i>
            <FormInputFile
              register={register}
              errors={errors}
              acceptFileType=".xlsx"
              id="file"
              name="file"
              disabled={!isEditable}
              fileChange={(e) => {
                handleFileChange(e);
              }}
              fileInputRef={importfileInputRef}
              limitSize="20MB"
            />
            <ImagePDFComponent
              wrapperClass="mt-2"
              file={importFileInfo}
              previewUrl={previewUrl}
              disabled={!isEditable}
              deleteImg={handleDeleteImg}
            />
          </div>
        }
      />
    </>
  );
};

export default FootprintInventory_Index;
